import { checkNull, isObjectNull } from "utils/utils";

const sportClubServiceName = "/SportClub";

export function sportClubService(http) {
    return {        
        getReservationsAsync: (userId, reservationDate, courtId) => {
            var parameterContainer = {
                creatorUserId: userId,
                startDate: reservationDate,
                courtId
            }
            return http.post(sportClubServiceName + "/GetReservationsAsync", parameterContainer)
        },
        getFloors: (isAdmin = false) => {
            let params = {
                isAdmin
            };

            return http.post(sportClubServiceName + "/GetFloors", params);
        }, 
        getMinimumAppointmentTimeEver: () => {
            return http.get(sportClubServiceName + "/getMinimumAppointmentTimeEver");
        },
        getAppointmentReportDataAsync: (parametersObject) => {
            return http.post(sportClubServiceName + "/GetAppointmentReportDataAsync", parametersObject);
        },
        getMaximumAppointmentTimeEver: () => {
            return http.get(sportClubServiceName + "/GetMaximumAppointmentTimeEver");
        },
        getFloorCourts: (floor, isAdmin = false) => {
            var parameter = {
                floor,
                isAdmin
            };
            return http.post(sportClubServiceName + "/GetFloorCourts", parameter);
        },
        getMaximumAvailableDayRule: _ =>{
            return http.get(sportClubServiceName + "/GetMaximumAvailableDayRule");
        },
        getMaximumAppointmentReservableInDaysRule: _ => {
            return http.get(sportClubServiceName + "/getMaximumAppointmentReservableInDaysRule");
        },
        getConferenceTypes: () => {
            return http.post(sportClubServiceName + "/GetConferenceTypes");
        },     
        getLaunchTypes: () => {
            return http.post(sportClubServiceName + "/GetLaunchTypes");
        },
        getRules: () => {
            return http.post(sportClubServiceName + "/GetRuls");
        },
        getCourts: () => {
            return http.post(sportClubServiceName + "/GetCourts");
        },    
        getHall: (hallId) => {

            return http.get(`${sportClubServiceName}/GetHall?hallId=${hallId}`);
        },    
        isUserAdministratorAsync: (userId) => {    
            let param = {
                UserId: userId
            }        
            return http.post(sportClubServiceName + "/IsUserAdministratorAsync", param);
        },
        updateSetting: (ruleList) => {
            return http.post(sportClubServiceName + "/UpdateSettingAsync", ruleList);
        },
        updateCourtsAvailability: (courtActivationList) => {
            return http.post(sportClubServiceName + "/UpdateCourtsAvailability", courtActivationList);
        },
        updateHallsChairs: (id, chairs, extraChairs) => {
            let param = {
                id,
                chairs,
                extraChairs
            } 
            debugger;
            return http.post(sportClubServiceName + "/UpdateHallChairsAsync", param);
        },        
        // isSystemPermittedUser: (userTypeId, userProfileId, isPowerUser) => {
        //     let param = {
        //         Id: userTypeId,
        //         UserProfileId: userProfileId,
        //         isPowerUser: isPowerUser
        //     }  
        //     return http.post(sportClubServiceName + "/IsSystemPermittedUser", param);
        // },
        saveReservationAsync: async (userId, title, description, startDate, endDate, courtId, playerNumber = null,playerCompany = null, playerIdentification = null, allDay, hasRacket = false, hasBall = false) => {
            var appointmentContainer = {
                creatorUserId: userId,
                title: title,
                description: description,
                stringStartDate: startDate,
                stringEndDate: endDate,
                courtId: courtId,
                playerNumber,
                playerCompany,
                playerIdentification,
                allDay: allDay,
                requirement:{
                    hasRacket,
                    hasBall                    
                }
            };

            return await http.post(sportClubServiceName + "/AddNewReservationAsync", appointmentContainer);                
        },
        confirmReservationAsync: async (id, userId, confirmationTime) => {
            var parameter = {
                Id: id,
                creatorUserId: userId,
                ConfirmationTime: confirmationTime
            };
            debugger;
            return http.post(sportClubServiceName + "/ConfirmReservationAsync",parameter);
        },
        removeReservation: async (id, userId) => {
            var parameter = {
                Id: id,
                omitterUserId: userId
            };
            return http.post(sportClubServiceName + "/RemoveReservation",parameter);
        },
        modifyReservation: async (id, requirementId, userId, title, description, startDate, endDate, courtId, playerNumber, playerCompany, playerIdentification, allDay, hasRacket, hasBall) => {
                debugger;
                var appointmentContainer = {
                    Id: id,
                    creatorUserId: userId,
                    title: title,
                    description: description,
                    startDate: startDate,
                    endDate: endDate,
                    courtId,
                    playerNumber,
                    playerCompany,
                    playerIdentification,
                    allDay: allDay,
                    requirement:{
                        id:requirementId,
                        hasRacket,
                        hasBall
                    }
                };
            return await http.post(sportClubServiceName + "/UpdateExistingReservationAsync",appointmentContainer);
        }          
    }
}
